import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { BoardMenuProvider } from '../../context/BoardMenuContext';

const ProjectLayout: React.FC = () => {
  const { projectCode } = useParams<{ projectCode: string }>();

  if (!projectCode) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <BoardMenuProvider projectCode={projectCode}>
      <Outlet />
    </BoardMenuProvider>
  );
};

export default ProjectLayout;
